export type PlanCurrency = 'USD' | 'EUR';

/** Cloudflare sets `currency=EUR` for visitors from eurozone countries; it picks the default display currency. */
export function planCurrency(cookie: string = document.cookie): PlanCurrency {
  return /(?:^|;\s*)currency=EUR(?:;|$)/.test(cookie) ? 'EUR' : 'USD';
}
